"use client";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-style/resolve-style/resolve-style.ts
function resolveStyle({ style, theme }) {
	if (Array.isArray(style)) return style.reduce((acc, item) => ({
		...acc,
		...resolveStyle({
			style: item,
			theme
		})
	}), {});
	if (typeof style === "function") return style(theme);
	if (style == null) return {};
	return style;
}
//#endregion
export { resolveStyle };

//# sourceMappingURL=resolve-style.mjs.map